module.exports = __webpack_public_path__ + "assets/img/公众号.d1d8d7c2.png";